<template>
  <div class="invite-search-dia">
    <van-dialog v-model="showDia" :showConfirmButton="false" :closeOnClickOverlay="false" @close="close" :lock-scroll="false">
      <div class="dialog" v-if="hostDate">
        <div class="avatar-name">
          <img class="avatar" :src="hostDate.avatar | imgPath" alt="" />
          <div class="name-id">
            <span class="name">{{ hostDate.nickname }}</span>
            <div class="id">
              <div class="id-icon"></div>
              {{ hostDate.presentId }}
            </div>
          </div>
        </div>
        <div class="title">{{ hostDate.title }}</div>
        <div class="content">
          {{ hostDate.content }}
        </div>
        <div class="btns">
          <div @click="handleRemove" class="btn btn1" v-if="hostDate.removable">{{ $t('lang.BaseModule.k049') }}</div>
          <div @click="handleOk" class="btn btn2">{{ $t('lang.BaseModule.k073') }}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// 邀请搜索弹框
export default {
  props: {
    showDia: {
      type: Boolean,
      default: false,
    },
    title: {},
    headline: {},
    oneShow: {
      type: Boolean,
      default: false,
    },
    hostDate: {},
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    handleOk() {
      this.$parent.closeSearchDia()
    },
    close() {
      this.$parent.closeSearchDia()
    },

    // 移除代理下的主播
    handleRemove() {
      this.$parent.removeBtn()
    },
  },
}
</script>

<style lang="scss" scoped>
.invite-search-dia {
  .dialog {
    width: 300px;
    margin: 0 auto;
    padding: 14px 16px 30px;
    background: #ffffff;
    border-radius: 12px;
    font-family: 'Inter-Regular';
    .avatar-name {
      display: flex;
      align-items: center;
      .avatar {
        width: 46px;
        height: 46px;

        object-fit: cover;
        border-radius: 50%;
      }
      .name-id {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .name {
          width: 150px;
          padding: 0 13px;
          font-size: var(--fs-16);
          line-height: var(--lh-title-24);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .id {
          display: flex;
          align-items: center;
          margin-top: 4px;
          padding: 0 10px;
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-body-20);
          color: #999999;

          .id-icon {
            width: 30px;
            height: 18px;
            margin: 0 3px;
            background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/id_icon.webp') left top / 100% 100% no-repeat;
          }
        }
      }
    }
    .title {
      margin: 26px 0 16px 0;
      font-weight: var(--fw-700);
      font-size: var(--fs-16);
      color: #333333;
      line-height: var(--lh-title-24);
      text-align: left;
    }
    .content {
      font-weight: var(--fw-500);
      font-size: var(--fs-14);
      color: #333333;
      line-height: var(--lh-body-20);
      text-align: left;
    }
    .btns {
      display: flex;
      justify-content: space-around;
      .btn {
        width: 240px;
        height: 40px;
        margin: 24px 10px 0;
        border-radius: 20px;
        font-weight: var(--fw-600);
        font-size: var(--fs-14);
        line-height: var(--lh-display-40);
        text-align: center;
      }
      .btn1 {
        background: #ffffff;
        color: #666666;
        border: 1px solid #e6e5e7;
      }
      .btn2 {
        background: #f8e5bd;
        color: #925e0d;
        border: 1px solid #f8e5bd;
      }
    }
  }
}
</style>

<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .invite-search-dia {
    .dialog {
      .title,
      .content {
        text-align: right;
      }

      .avatar-name .name-id .id .id-icon {
        background-position: right top;
      }
    }
  }
}
</style>
